function ListLoader() {
  return (
    <div className="px-spinner-wrap">
        <div className="px-spinner"></div>
    </div>
  );
}

export default ListLoader;